import React from 'react';
import { Card, Descriptions, Skeleton } from 'antd';
import { formatSourceDate } from '../utils.jsx';

const MoveGroupInformation = React.memo(({ moveGroup, isFetching }) => {
    if (!moveGroup) return null;

    if (isFetching) {
        return (
            <Card title="Move Group Information" size="small">
                <Skeleton active />
            </Card>
        );
    }

    return (
        <Card title="Move Group Information" size="small">
            <Descriptions column={1} size="small">
                <Descriptions.Item label="Move Group">{moveGroup.name}</Descriptions.Item>
                <Descriptions.Item label="Target Migration Date">
                    {moveGroup.target_migration_date ? formatSourceDate(moveGroup.target_migration_date) : 'Not set'}
                </Descriptions.Item>
                <Descriptions.Item label="Assigned Resource">
                    {moveGroup.assigned_resource_email || 'Not set'}
                </Descriptions.Item>
            </Descriptions>
        </Card>
    );
});

MoveGroupInformation.displayName = 'MoveGroupInformation';

export default MoveGroupInformation;
